/* eslint-disable */
import React from 'react'
import { compose } from 'recompose'
import { withStyles, Grid, Button, Menu, MenuItem, Typography } from '@material-ui/core'
import cn from 'classnames'
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import BusinessIcon from '@material-ui/icons/Business';
import CloseIcon from '@material-ui/icons/Close';
import DateRangeIcon from '@material-ui/icons/DateRange';
import ErrorIcon from '@material-ui/icons/Error';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import ModeCommentIcon from '@material-ui/icons/ModeComment';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import ViewColumnIcon from '@material-ui/icons/ViewColumn';
import VisibilityIcon from '@material-ui/icons/Visibility';
import themeCreateInjectableStyles from '../../../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support'
import DownloadBarStyles from './DownloadBar.component.styles'

const DownloadBar = (props) => {
  const {
    classes,
    checked,
    selected,
    smallScreen,
    setExportRowsMenu,
    exportRowsMenu,
    getDocketsCsv,
    downloadPdfDockets,
  } = props

  return (
    <Grid className={cn(classes.downloadBar, !checked.length && classes.hiddenBar)} container justify="flex-start" spacing={0}>
      <Grid item xs={12}>
        <Grid alignItems="center" className={classes.flexWrapNowrap} container justify={smallScreen ? `space-between` : `flex-start`} spacing={2}>
          <Grid item>{selected}</Grid>
          <Grid item>
            <Button aria-label="Download" color="inherit" edge="start" onClick={(e) => setExportRowsMenu(e.currentTarget)}>
              <SaveAltIcon className={classes.iconLeft} />
              Export Rows
            </Button>

            <Menu disableAutoFocusItem anchorEl={exportRowsMenu} onClose={() => setExportRowsMenu(null)} open={!!exportRowsMenu}>
              <MenuItem disabled>
                <Typography variant="subtitle2" className={classes.menuHeading}>
                  Export <b>selected rows</b> from <b>current view</b>
                </Typography>
              </MenuItem>
              <MenuItem onClick={getDocketsCsv}>
                <LibraryBooksIcon className={classes.iconLeft} />
                Download CSV
              </MenuItem>
              <MenuItem onClick={downloadPdfDockets}>
                <PictureAsPdfIcon className={classes.iconLeft} />
                Download PDF
              </MenuItem>
            </Menu>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default compose(
  withStyles(themeCreateInjectableStyles(DownloadBarStyles), { withTheme: true }),
)(DownloadBar)
